import { PageHead } from "@generalapplications/html-render/react";
import { useLocation } from "react-router-dom";
import { PageHeroCta } from "@/app/pages/notFound/components/PageHeroCta";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { notFoundPage } from "@/content/notFound";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { PageArticle } from "@generalapplications/ui";

export function NotFoundPage() {
  const { pathname } = useLocation();
  const head = pageHead({
    path: pathname,
    title: notFoundPage.seoTitle,
    description: notFoundPage.seoDescription,
    noIndex: true,
  });

  return (
    <PageArticle centered>
      <PageHead head={head} />
      <PageHero headline={notFoundPage.headline} copy={[notFoundPage.copy]}>
        <PageHeroCta to={routes.home}>{notFoundPage.cta}</PageHeroCta>
      </PageHero>
    </PageArticle>
  );
}
